<template>
    <VJoyTooltip v-if="location.city || location.countryCode">
        <template #tooltip-content>
            <p v-if="cityAndCountryLabel" class="joy-mb-2">
                {{ cityAndCountryLabel }}
            </p>
            <p>
                {{ locationHint }}
            </p>
        </template>

        <VJoyWrapper
            no-margin
            row-gap="1"
            column-gap="1"
            wrap="nowrap"
            align="flex-start"
            class="profile-location"
            :class="{'profile-location--compact': compactMode}"
        >
            <VJoyIcon name="location" class="profile-location__icon" />
            <div class="profile-location__text">
                <span v-if="location.city" class="profile-location__city">{{ location.city }}{{ location.countryCode ? ',&nbsp;' : '' }}</span>
                {{ location.countryCode }}
            </div>
        </VJoyWrapper>
    </VJoyTooltip>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyIcon, VJoyTooltip, VJoyWrapper} from '@maltjoy/core-vue';
    import {useLocationHint} from './useLocationHint';

    const props = defineProps<{
        location: {
            city?: string;
            locationType: string;
            countryCode?: string;
            country?: string;
        };
        firstName: string;
        targetCity?: string;
        compactMode?: boolean;
    }>();

    const {locationHint} = useLocationHint(props.firstName, props.location, props.targetCity);

    const cityAndCountryLabel = computed(() => {
        const {city, country} = props.location;
        if (city && country) {
            return `${city}, ${country}`;
        } else if (city) {
            return city;
        } else if (country) {
            return country;
        }
        return undefined;
    });
</script>

<style scoped lang="scss">
    .profile-location {
        max-width: 200px;
        column-gap: 2px;

        &--compact {
            max-width: 160px;
        }

        &__text {
            font-weight: var(--joy-font-weight-bold);
            text-wrap: nowrap;
            display: inline-flex;
            overflow: hidden;
        }

        &__city {
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &__icon {
            color: var(--joy-color-primary-50);
        }
    }
</style>
